import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Bind } from 'lodash-decorators/bind';
import { observer } from 'mobx-react';
import Link from 'common/components/LocalizedLink/LocalizedLink';
import { ANCHOR } from 'common/consts/common';
import LanguageService from 'services/Language.service';

import PeopleStore from 'stores/People.store';

import messages from './EmployeeList.intl';

import styles from './EmployeeList.module.scss';

import EmployeeCard from '../EmployeeCard/EmployeeCard';
import EmployeeTile from '../EmployeeTile/EmployeeTile';
import Placeholder from 'common/components/Placeholder/Placeholder';
import ContentBar from 'common/components/Placeholder/components/ContentBar/ContentBar';

@injectIntl
@observer
export default class FiltersComponent extends Component {
  static propTypes = {
    className: PropTypes.string,
    handler: PropTypes.func.isRequired,
    selectedPerson: PropTypes.number
  };

  static defaultProps = {
    className: ''
  };

  currentLanguage = LanguageService.getLang();

  async componentDidMount() {
    await PeopleStore.fetchPeople();
  }

  render() {
    const { className, selectedPersonIndex, scope } = this.props;
    const people = PeopleStore.getPeopleByPositionType(scope);

    return (
      <div className={className}>
        <Placeholder
          component={<ContentBar className={styles.PlaceholderTile} />}
          ready={!!people.length}
        >
          <div className={styles.EmployeeList}>
            {people.map((person, index) => (
              <EmployeeTile
                key={person.system.codename}
                index={index}
                handler={this.selectedTileHandler}
                photo={person.photo}
                firstName={person.firstName}
                lastName={person.lastName}
              />
            ))}
            <Link to={ANCHOR.JOBOFFERS[this.currentLanguage]}>
              <input
                type="button"
                className={styles.JoinUsBtn}
                value={this.props.intl.formatMessage(messages.button)}
              />
            </Link>
          </div>
        </Placeholder>
        <Placeholder
          component={<ContentBar className={styles.PersonCardPlaceholder} />}
          ready={!!people.length}
        >
          {people[selectedPersonIndex] && (
            <EmployeeCard employee={people[selectedPersonIndex]} />
          )}
        </Placeholder>
      </div>
    );
  }

  @Bind()
  selectedTileHandler(e) {
    this.props.handler(e);
  }
}



// WEBPACK FOOTER //
// ./src/views/TeamOfExperts/components/EmployeesList/EmployeeList.js